import React from 'react';
import styled, { css } from 'styled-components/macro';
import { ReactComponent as Chevron } from 'icons/icon-chevron.svg';
import { ReactComponent as MagnifyingGlass } from 'icons/icon-search.svg';
import { SearchFieldBlock } from 'components/data-containers/BrowseEntities/shared/styles';

export const FakeButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media screen and (min-width: 50em) {
    flex-wrap: nowrap;
  }
`;

const FakeButtonStyles = css`
  flex-basis: 5em;
  font-weight: 600;
  text-align: center;
  padding: ${({ theme }): any =>
    `${theme.spacing.small} ${theme.spacing.large}`};
  white-space: nowrap;
`;
export const FakeButton = styled.span<{ active: boolean }>`
  ${FakeButtonStyles};
  flex: 1 1;
  ${({ active, theme }): any => css`
    color: ${active ? 'white' : theme.DeepBlue};
    background: ${active ? theme.AccentGreen : theme.Sand};
  `}
`;

export const FakeRedesignButton = styled.span<{ active: boolean }>`
  flex-basis: 5em;
  font-weight: normal;
  text-align: center;
  padding: ${({ theme }): any =>
    `${theme.spacing.medium} ${theme.spacing.xlarge}`};
  white-space: nowrap;
  font-size: 0.7em;
  flex: 1 1;
  ${({ active, theme }): any => css`
    color: ${active ? 'white' : theme.DeepBlue};
    background: ${active ? theme.AccentGreen : theme.Sand};
  `}
`;

const StyledChevron = styled(Chevron)`
  transform: rotate(0.25turn);
`;

export const FakeDropdownWrapper = styled.div<any>`
  ${FakeButtonStyles};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }): any => theme.Sand};
  color: ${({ theme }): any => theme.NightBlue};
  margin-right: auto;

  ${({ active, theme }): any => css`
    color: ${active ? 'white' : theme.DeepBlue};
    background: ${active ? theme.AccentGreen : theme.Sand};
  `}

  ${StyledChevron} {
    ${({ theme, active }): any => css`
      color: ${active ? 'white' : theme.AccentGreen};
      width: ${theme.spacing.small};
      height: ${theme.spacing.small};
      margin-left: ${theme.spacing.small};
    `}
  }
`;

const FakeDropdownLabel = styled.span`
  flex: 1;
`;

export const FakeDropdown = (props: any): JSX.Element => {
  return (
    <FakeDropdownWrapper active={props.active}>
      <FakeDropdownLabel>{props.children}</FakeDropdownLabel> <StyledChevron />
    </FakeDropdownWrapper>
  );
};

export const FullScreenDropdownWrapper = styled.div`
  flex: 1;
`;

const Toggle = styled('div')`
  flex: 0;
  display: flex;
  background: ${({ theme }): any => theme.Sand};
  color: ${({ theme }): any => theme.NightBlue};
  font-weight: 600;
  line-height: 0.6;
`;

const ToggleWrapper = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: ${({ theme }): any =>
    `${theme.spacing.small} ${theme.spacing.medium}`};
`;

const SortCaret = styled('span')<{ isActive?: boolean | undefined }>`
  transition: ${({ theme }): any =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  opacity: ${({ isActive }): any => (isActive ? 1 : 0.25)};
  transform: scaleY(0.75);
`;

export const FakeSortToggle = (): JSX.Element => {
  return (
    <Toggle>
      <ToggleWrapper>
        <SortCaret>&#9650;</SortCaret>
        <SortCaret isActive>&#9660;</SortCaret>
      </ToggleWrapper>
    </Toggle>
  );
};

const StyledMagnifyingGlass = styled(MagnifyingGlass)`
  width: 1.2em;
  height: 1.2em;

  ${({ theme }): any => css`
    color: ${theme.AccentGreen};
    margin-right: ${theme.spacing.small};
  `}
`;

const FakeSearchWrapper = styled.div`
  ${FakeButtonStyles};
  padding: ${({ theme }): any =>
    `${theme.spacing.small} ${theme.spacing.medium}`};
  flex-basis: 13.5em;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  font-weight: 400;
  background: ${({ theme }): any => theme.Sand};
  color: ${({ theme }): any => theme.CasperGrey};
`;

export const FakeSearch = (props: any): JSX.Element => {
  return (
    <FakeSearchWrapper>
      <StyledMagnifyingGlass /> <span>{props.children}</span>
    </FakeSearchWrapper>
  );
};

export const FakeControls = styled('div')<any>`
  display: block;

  ${SearchFieldBlock} {
    margin-bottom: 0.5em;
  }
  ${FakeDropdownWrapper} {
    margin-bottom: ${({ theme }): string => theme.spacing.small};
    padding: ${({ theme, browseRelated }): string =>
      browseRelated ? '0;' : `${theme.spacing.small} ${theme.spacing.xlarge};`};
    text-transform: capitalize;
  }
`;

export const FakeTabsBlock = styled('div')`
  display: flex;
  margin: ${({ theme }): string => theme.spacing.small} 0;
`;

export const FakeTab = styled('div')<any>`
  position: relative;
  z-index: 2;
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.xlarge}`};
  text-transform: uppercase;
  font-weight: 600;

  ${({ active, theme }): any => css`
    color: ${active ? theme.NightBlue : theme.CasperGrey};
    border-bottom: 4px solid ${active ? theme.AccentGreen : 'transparent'};
  `}
`;

export const FakeSortWrapper = styled('div')<any>`
  display: flex;

  ${FakeDropdownWrapper} {
    flex-basis: 100%;
    margin-right: ${({ theme, isFakeSortToggle }): string =>
      isFakeSortToggle ? 0 : theme.spacing.small};
  }
  ${Toggle} {
    align-items: center;
    margin-bottom: ${({ theme }): string => theme.spacing.small};
  }
`;
